import React, { useContext, useEffect, useState } from "react";
import OfflineHeader from "../OfflineHeader/OfflineHeader";
import trans from "../../../utils";
import Button from "../../Helpers/Button/Button";
import { Tag } from "antd";
import AntdTable from "../../antd/Table/Table";
import { useNavigate } from "react-router-dom";
import { getAllData, getData } from "../../../utils/IndexedDB";
import IRHead from "./IRHead";
import Actions from "../../antd/Table/Actions";
import { popupcontext } from "../../../context/Popupscontext";
import IROfflinePopup from "./IROfflinePopup/IROfflinePopup";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { IRQAModal } from "./IROfflinePopup/IROfflineQA";
function BTN() {
	const navigate = useNavigate();
	return (
		<>
			<Button
				text={trans("Add New IR")}
				onClick={() => navigate("/IR-offline-control")}
				type={"primary"}
			/>
		</>
	);
}
export default function IR() {
	const [tableData, setTableData] = useState(null);
	const [configData, setConfigData] = useState(null);
	const [limit, setLimit] = useState(10);
	const [currentPage, setCurrentPage] = useState(1);
	const { deleted, setDeleted, currentIRId } = useContext(popupcontext);
	const [qaAction, setQAAction] = useState(false);
	const [irId, setIRId] = useState(null);
	const [action, setAction] = useState(false);
	const [qacData, setQACData] = useState(null);
	const inf = useSelector((state) => state.users.user);
	console.log("CurrentIRID", currentIRId);
	const fetchData = async () => {
		try {
			const data = await getAllData("OfflineModeData", "IR");
			const fdata = await getAllData("OfflineModeData", "IRQA");
			setTableData(data);
			setQACData(fdata);
		} catch (error) {
			console.error("IndexedDB read error:", error);
		}
	};
	const fetchConfigData = async () => {
		try {
			const data = await getAllData("OfflineModeData", "configurationStore");
			setConfigData(data);
		} catch (error) {
			console.error("IndexedDB read error:", error);
		}
	};
	const openPDFFromCache = async (allData) => {
		const fileKey = `${allData?.ir_number || allData?.id}-Rev-${allData.revision_number}`;

		try {
			const record = await getData("OfflineModeData", "PDFFiles", fileKey);

			if (record?.blob) {
				const url = URL.createObjectURL(record.blob);
				window.open(url, "_blank");
			} else {
				toast.error(
					trans(
						"PDF not found in cache, Please wait whilefetching from server...",
					),
					{
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar",
					},
				);
				// Fallback: fetch fresh from server and open
				// const baseUrl = process.env.REACT_APP_BACKEND2_URL || "";
				// const url = `${baseUrl}/v1/inspection-requests/${allData.id}/hdb_pdf?revisionNumber=${allData.revision_number}&revisionType=${allData.revision_type}`;
				// window.open(url, "_blank");
			}
		} catch (error) {
			console.error("Error opening PDF:", error);
		}
	};
	useEffect(() => {
		fetchData();
		fetchConfigData();
	}, []);

	useEffect(() => {
		if (deleted || action) {
			fetchData();
			setDeleted(false);
			setAction(false);
		}
	}, [deleted, action]);
	const statusColor = {
		"Pending Sync": `orange`,
		Synced: "green",
		Failed: "red",
		Syncing: "blue",
	};
	const statusColors = {
		CLOSED: `blue`,
		PENDING_QA: `orange`,
		PENDING_CONSULTANT: `orange`,
		PENDING_REVIEW: `orange`,
		QA_APPROVED: `green`,
		APPROVED: `green`,
		CONSULTANT_APPROVED: `green`,
		QA_REJECTED: `red`,
		CONSULTANT_REJECTED: `red`,
		REJECTED: `red`,
		CONSULTANT_APPROVED_WITH_COMMENTS: `purple`,
		APPROVED_WITH_COMMENTS: `purple`,
		DRAFT: `default`,
		CANCELLED: `default`,
	};
	const IRColumns = [
		{
			title: trans("IR Number"),
			key: "id",
			dataIndex: "id",
			width: 200,
			render: (text, record) => {
				return <span>{record?.id || record?.ir_number || "- - - - - -"}</span>;
			},
		},
		{
			title: trans("Project"),
			key: "project_name",
			dataIndex: "project_name",
			width: 200,
			render: (text, record) => {
				return (
					<span>
						{record?.project_name || record?.project?.name || "- - - - - -"}
					</span>
				);
			},
		},

		{
			title: trans("Building"),
			key: "zone_name",
			dataIndex: "zone_name",
			width: 200,
			render: (text, record) => {
				return (
					<span>
						{record?.zone_name || record?.zone?.name || "- - - - - -"}
					</span>
				);
			},
		},
		{
			title: trans("Level"),
			key: "level_name",
			dataIndex: "level_name",
			width: 200,
			render: (text, record) => {
				return (
					<span>
						{record?.level_name || record?.level?.name || "- - - - - -"}
					</span>
				);
			},
		},
		{
			title: trans("Space"),
			key: "room_name",
			dataIndex: "room_name",
			width: 200,
			render: (text, record) => {
				return (
					<span>
						{record?.room_name || record?.room?.name || "- - - - - -"}
					</span>
				);
			},
		},
		{
			title: trans("Ready Date"),
			key: "ready_date",
			dataIndex: "ready_date",
			width: 150,
		},
		{
			title: trans("Discipline"),
			key: "discipline",
			dataIndex: "discipline",
			width: 150,
		},
		{
			title: trans("Status"),
			key: "status",
			dataIndex: "status",
			width: 150,
			render: (_, record) => {
				return (
					<>
						{record?.status ? (
							<Tag color={statusColors[record?.status] || "default"}>
								{trans(record?.status)}
							</Tag>
						) : (
							"- - - - - -"
						)}
					</>
				);
			},
		},
		{
			title: trans("Status Sync"),
			key: "statusSync",
			dataIndex: "statusSync",
			width: 150,
			render: (_, record) => {
				return (
					<>
						{record?.statusSync ? (
							<Tag color={statusColor[record?.statusSync] || "default"}>
								{trans(record?.statusSync)}
							</Tag>
						) : (
							"- - - - - -"
						)}
					</>
				);
			},
		},
		{
			title: trans("Form"),
			key: "form_name",
			dataIndex: "form_name",
			width: 150,
			render: (text, record) => {
				return (
					<span>
						{record?.form_name || record?.form?.name || "- - - - - -"}
					</span>
				);
			},
		},
		{
			title: trans("Actions"),
			key: "actions",
			fixed: "right",
			width: 120,
			render: (_, record) => {
				return (
					<>
						{inf?.attributes?.role === "contractor" && record?.statusSync && (
							<Actions irId={record.id} name={record.name} type="offlineMode" />
						)}
						{inf?.attributes?.role === "qa" && (
							<Button
								disabled={
									record?.status !== "PENDING_QA" ||
									record?.statusSync === "Pending Sync" ||
									qacData?.some((i) => i?.id === record?.id)
								}
								onClick={async (e) => {
									await e.stopPropagation();
									await setIRId(record);
									await setQAAction(true);
								}}
							>
								{trans("Review")}
							</Button>
						)}
					</>
				);
			},
		},
	];
	const [query, setQuery] = useState("");

	const filteredData =
		tableData?.filter((item) => {
			const matchesConfig = configData?.some(
				(config) => config.name === item.configurationName,
			);
			if (!matchesConfig) return false;
			if (!query || !query.trim()) return true;
			return Object.values(item).some((value) =>
				String(value).toLowerCase().includes(query.toLowerCase()),
			);
		}) || [];

	const handleQueryChange = (e) => {
		// Handle both event objects and direct string values
		const newQuery = typeof e === "string" ? e : e?.target?.value || "";
		setQuery(newQuery);
		setCurrentPage(1);
	};
	return (
		<>
			<Helmet>
				<title>Inspection Request</title>
				<meta name="description" content="IR" />
			</Helmet>
			<OfflineHeader
				title={trans("Inspection Request (IR)")}
				subTitle={trans(
					"You are working offline. Data will sync automatically when connection returns.",
				)}
				btn={inf?.attributes?.role === "contractor" && BTN()}
				online={true}
			/>
			<IRHead query={query} setQuery={handleQueryChange} />
			<div className="bg-white-rounded-top table-parent mt-2">
				<AntdTable
					columns={IRColumns}
					dataSource={filteredData || []}
					loading={false}
					pageSize={limit}
					totalItems={filteredData?.length || 0}
					currentPage={currentPage}
					onPageChange={(page) => setCurrentPage(page)}
					onLimitChange={(newLimit) => {
						setLimit(newLimit);
						setCurrentPage(1);
					}}
					onRow={(record) => ({
						onClick: (e) => {
							if (record?.status) {
								e.stopPropagation();
								openPDFFromCache(record);
							}
						},
						style: { cursor: record?.status ? "pointer" : "default" }, // shows pointer cursor on hover
					})}
				/>
			</div>
			<IROfflinePopup />
			<IRQAModal
				qaAction={qaAction}
				setQAAction={setQAAction}
				setIRId={setIRId}
				irId={irId}
				setAction={setAction}
			/>
		</>
	);
}
